/**
 * Diego Cabero. Adapter for eTracker.
 */
define([], () => {
    return (ea, config, plugins = []) => {

        function trackPageView({payload: {path, parameters}}) {

            if (window.et_eC_Wrapper) {

                if (path) {
                    // triggered for the non-1st page
                    // et_eC_Wrapper interface: eTrackerTrakingId, et_pagename, et_areas, h, et_url, et_target, et_tval, et_tonr, et_tsale, et_cust, et_basket, et_lpage, et_trig, et_tag, et_sub
                    window.et_eC_Wrapper(config.trackingID, parameters.pagename, parameters.areas, undefined, window.location.href, parameters.target, parameters.tval, parameters.transactionNumber, parameters.sales, undefined, undefined, undefined, undefined, parameters.tag);
                }

            } else {
                $(window).on('load', () => {
                    if (path) {
                        // triggered for the 1st page
                        // et_eC_Wrapper interface: eTrackerTrakingId, et_pagename, et_areas, h, et_url, et_target, et_tval, et_tonr, et_tsale, et_cust, et_basket, et_lpage, et_trig, et_tag, et_sub
                        window.et_eC_Wrapper(config.trackingID, parameters.pagename, parameters.areas, undefined, window.location.href, parameters.target, parameters.tval, parameters.transactionNumber, parameters.sales, undefined, undefined, undefined, undefined, parameters.tag);
                    }
                });
            }
        }

        function trackServerCall({
            payload: {
                success, elapsedTime, path, method,
            },
        }) {
            ea('send', {
                hitType: 'event',
                eventCategory: 'serverCall',
                eventAction: `${path}:${method}`,
                eventLabel: success ? 'success' : 'failure',
                eventValue: elapsedTime,
            });
        }

        function trackWizard({eventName}) {
            ea('send', {
                hitType: 'event',
                eventCategory: 'wizard',
                eventAction: eventName,
            });
        }

        function trackPurchase({
            payload: {
                id, offering, taxes, total, productName,
            },
        }) {
            ea('ecommerce:addTransaction', {
                id,
                revenue: total.amount,
                tax: taxes.amount,
                currency: total.currency,
            });
            ea('ecommerce:addItem', {
                id,
                name: productName,
                category: offering,
                price: total.amount - taxes.amount,
                currency: total.currency,
            });
            ea('ecommerce:send');
        }

        // Create a new tracker
        ea('create', config);
        plugins.forEach(pluginName => ea('require', pluginName));
        return {
            trackPageView,
            trackServerCall,
            trackWizard,
            trackPurchase,
        };
    };
});



// WEBPACK FOOTER //
// ./app/customer/js/src/edge/platform/tracking/adapters/eTrackerAdapter.js